import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { initSentry } from '../../shared/src/config/sentry';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/notifications/styles.css';

import { theme } from '@/theme';
import router from '@/router';
import { queryClient } from '@/config/queryClient';
import ErrorBoundary from '@/components/ErrorBoundary';
import OfflineProvider from '@/components/OfflineProvider';

// ---------------------------------------------------------------------------
// Sentry Initialization
// ---------------------------------------------------------------------------

initSentry(
  import.meta.env.VITE_SENTRY_DSN,
  import.meta.env.VITE_ENV || 'development',
);

// ---------------------------------------------------------------------------
// Render
// ---------------------------------------------------------------------------

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <Notifications position="top-right" aria-live="polite" />
        <OfflineProvider>
          <ErrorBoundary>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </OfflineProvider>
      </MantineProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
